import { ReactNode } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material';
import { theme, embraceTheme } from '@care/material-ui-theme';
import { CLIENT_FEATURE_FLAGS } from '@/constants';
import { useFeatureFlags } from '../contexts/FeatureFlagsContext';

/**
 * Renders the theme provider with the correct theme based on the feature flags
 */
const ThemeProvider = ({ children }: { children: ReactNode }) => {
  const { isFeatureFlagActive } = useFeatureFlags();
  const showEmbraceTheme =
    isFeatureFlagActive && isFeatureFlagActive(CLIENT_FEATURE_FLAGS.EMBRACE_THEME);

  return (
    <MuiThemeProvider theme={showEmbraceTheme ? embraceTheme : theme}>{children}</MuiThemeProvider>
  );
};

export default ThemeProvider;
